import classNames from "classnames";

interface Props {
  children: React.ReactNode;
  onClick?: () => void;
  menuExpanded?: boolean;
}

const LiItem = ({ children, onClick, menuExpanded }: Props) => (
  <li
    data-testid="menu-item"
    className={classNames(
      "transition duration-200 cursor-pointer tracking-normal text-sm",
      {
        "px-2 py-0.5": menuExpanded,
        "px-1 py-0.5": !menuExpanded,
      }
    )}
    onClick={onClick}
  >
    {children}
  </li>
);

export default LiItem;
